import BaseChangeset from './base';
export class ForgotPasswordChangeset extends BaseChangeset {}